"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNormalizedSizes = void 0;
require("../../..");
require("../../../../core");
const getNormalizedSizes = (data) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let maxSizeIndex = 0;
    data.forEach((item) => {
        const temp = sizes.indexOf(item.suffix);
        if (temp > maxSizeIndex) {
            maxSizeIndex = temp;
        }
    });
    return data.map((item) => item.value / Math.pow(1024, (maxSizeIndex - sizes.indexOf(item.suffix))));
};
exports.getNormalizedSizes = getNormalizedSizes;
//# sourceMappingURL=getNormalizedSizes.js.map